"use strict";
/**
 * Posta dei ticket (ADR-003, story #37): motivi e stati delle email in uscita, eventi di consegna
 * del thread e codici di errore della porta di invio. Le story che spediscono (#4 assegnazione,
 * #5 risposte, #6 chiusura) scelgono il motivo; lo stato lo aggiornano i webhook del fornitore.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBHOOK_ERROR_CODES = exports.RECEIPT_CONFIRMATION_FAILURE_LABELS = exports.MAIL_FAILURE_FALLBACK = exports.MAIL_FAILURE_LABELS = exports.MAIL_ERROR_CODES = exports.RECEIPT_CONFIRMATION_ACTOR = exports.TICKET_RECEIPT_EVENT_TYPE_LABELS = exports.TICKET_RECEIPT_EVENT_TYPES = exports.TICKET_EMAIL_EVENT_TYPE_LABELS = exports.TICKET_EMAIL_EVENT_TYPES = exports.TICKET_EMAIL_STATE_LABELS = exports.TICKET_EMAIL_STATES = exports.TICKET_EMAIL_REASON_LABELS = exports.TICKET_EMAIL_REASONS = void 0;
exports.isTeamNotificationReason = isTeamNotificationReason;
exports.ticketSubjectPrefix = ticketSubjectPrefix;
/**
 * Perché parte un'email del ticket. `notifica_replica` è l'avviso al responsabile quando il
 * segnalante risponde (ADR-003, in entrata punto 6); `prova` è l'email di verifica del runbook
 * RUN-006, spedita a una casella aziendale a scelta; `conferma_ricezione` è la conferma automatica
 * a chi ha segnalato dal canale in piattaforma, all'apertura del ticket (#117). L'ordine è quello
 * degli `ADD VALUE` dell'enum nel database (0007, 0018).
 */
exports.TICKET_EMAIL_REASONS = [
    'notifica_assegnazione',
    'notifica_replica',
    'risposta',
    'chiusura',
    'prova',
    'conferma_ricezione',
];
exports.TICKET_EMAIL_REASON_LABELS = {
    notifica_assegnazione: 'Notifica di assegnazione',
    notifica_replica: 'Notifica di replica',
    risposta: 'Risposta',
    chiusura: 'Chiusura',
    prova: 'Email di prova',
    conferma_ricezione: 'Conferma di ricezione',
};
/** Le notifiche interne al team: al responsabile o a chi è assegnato, mai al segnalante (#70). */
const TEAM_NOTIFICATION_REASONS = ['notifica_assegnazione', 'notifica_replica'];
/**
 * Vero se il motivo è una notifica interna al team (#70): i suoi esiti di consegna non sono
 * un'email al segnalante e nel thread si leggono come «Notifica consegnata a <nome>».
 */
function isTeamNotificationReason(reason) {
    return TEAM_NOTIFICATION_REASONS.includes(reason);
}
/**
 * Stato di un'email in uscita. `in_invio` dura il tempo della chiamata al fornitore (una riga
 * rimasta così indica un processo interrotto: l'esito è ignoto, mai «inviata»); `inviata` = accettata
 * dal fornitore; `consegnata`, `rimbalzata`, `reclamo` arrivano dal webhook; `fallita` = il
 * fornitore ha rifiutato o non era raggiungibile, oppure la posta non è configurata.
 */
exports.TICKET_EMAIL_STATES = ['in_invio', 'inviata', 'consegnata', 'rimbalzata', 'reclamo', 'fallita'];
exports.TICKET_EMAIL_STATE_LABELS = {
    in_invio: 'In invio',
    inviata: 'Inviata',
    consegnata: 'Consegnata',
    rimbalzata: 'Non recapitata',
    reclamo: 'Segnalata come spam',
    fallita: 'Invio non riuscito',
};
/**
 * Tipi di evento del thread generati dalla posta (DEC-002 regola 1, ADR-003 in uscita punto 4):
 * consegna, mancato recapito e segnalazione come spam di un'email del ticket.
 */
exports.TICKET_EMAIL_EVENT_TYPES = ['email_consegnata', 'email_rimbalzata', 'email_reclamo'];
exports.TICKET_EMAIL_EVENT_TYPE_LABELS = {
    email_consegnata: 'Email consegnata',
    email_rimbalzata: 'Email non recapitata',
    email_reclamo: 'Email segnalata come spam',
};
/**
 * Evento del thread della conferma di ricezione (#117): la console ha scritto a chi ha segnalato
 * che il ticket è aperto. `details` = `{ emailId, esito, errore }`: `esito` `in_invio` finché l'invio
 * non ha un esito, poi `inviata` o `non_inviata` con il codice d'errore della porta di invio.
 */
exports.TICKET_RECEIPT_EVENT_TYPES = ['conferma_ricezione'];
exports.TICKET_RECEIPT_EVENT_TYPE_LABELS = {
    conferma_ricezione: 'Conferma di ricezione inviata',
};
/** Autore dell'evento `conferma_ricezione`: nessuna persona, è la console all'apertura del ticket. */
exports.RECEIPT_CONFIRMATION_ACTOR = 'Conferma automatica';
/** Codici di errore della posta, nel campo `code` del corpo di errore dell'API. */
exports.MAIL_ERROR_CODES = {
    /** Nessuna API key del fornitore: l'istanza non spedisce email (RUN-006). Mai un successo finto. */
    notConfigured: 'mail.not_configured',
    /** Il fornitore ha rifiutato l'email o non ha risposto: nulla risulta inviato. */
    sendFailed: 'mail.send_failed',
    /** Destinatario non valido come indirizzo email. */
    invalidRecipient: 'mail.invalid_recipient',
    /** Ticket inesistente. */
    ticketNotFound: 'mail.ticket_not_found',
};
/**
 * Perché un'email automatica non è partita, in italiano, dal codice d'errore della porta di invio:
 * la parte comune alla notifica di assegnazione (#4) e alla conferma di ricezione (#117), che
 * aggiungono il destinatario non valido con le loro parole.
 */
exports.MAIL_FAILURE_LABELS = {
    [exports.MAIL_ERROR_CODES.notConfigured]: 'la posta non è configurata su questa istanza',
    [exports.MAIL_ERROR_CODES.sendFailed]: 'il fornitore della posta non ha accettato l’email',
};
/** Motivo di un'email non partita con un codice non previsto. */
exports.MAIL_FAILURE_FALLBACK = 'errore inatteso durante l’invio';
/** Perché la conferma di ricezione non è partita (#117). */
exports.RECEIPT_CONFIRMATION_FAILURE_LABELS = {
    ...exports.MAIL_FAILURE_LABELS,
    [exports.MAIL_ERROR_CODES.invalidRecipient]: 'l’indirizzo di chi ha segnalato non è valido',
};
/** Codici di errore dei webhook dei fornitori. Nessun dettaglio sul perché la firma è rifiutata. */
exports.WEBHOOK_ERROR_CODES = {
    /** Firma assente, scaduta o errata. */
    invalidSignature: 'webhooks.invalid_signature',
    /** Segreto di firma non configurato: l'istanza non accetta eventi (RUN-006). */
    notConfigured: 'webhooks.not_configured',
    /** Corpo firmato ma non leggibile come evento. */
    invalidPayload: 'webhooks.invalid_payload',
    /**
     * Il testo di un'email ricevuta non si legge dal fornitore (rete, permesso della API key): nulla è
     * registrato e il fornitore ritenta la consegna (#42).
     */
    contentUnavailable: 'webhooks.content_unavailable',
};
/** Prefisso dell'oggetto di ogni email del ticket (ADR-003): `[EC-2026-0001]`. */
function ticketSubjectPrefix(code) {
    return `[${code}]`;
}
//# sourceMappingURL=ticket-emails.js.map